import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: 'Page not found',
  subheader: 'Sorry, the page you were looking for could not be found.',
  buttonText: 'Return to homepage',
}
